export default function ButtonLogoGoogle() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.4 8.14396C14.4 7.72262 14.3619 7.32262 14.2965 6.93329H8.1389V9.33862H11.6645C11.5065 10.128 11.0433 10.7946 10.3567 11.248V12.848H12.4601C13.6916 11.7333 14.4 10.0906 14.4 8.14396Z"
        fill="#4285F4"
      />
      <path
        d="M8.13888 14.4001C9.90442 14.4001 11.3811 13.8241 12.4601 12.8481L10.3567 11.2481C9.76819 11.6321 9.02165 11.8668 8.13888 11.8668C6.43329 11.8668 4.98926 10.7414 4.47159 9.22144H2.30281V10.8694C3.3763 12.9601 5.58322 14.4001 8.13888 14.4001Z"
        fill="#34A853"
      />
      <path
        d="M4.47172 9.22128C4.3355 8.83728 4.26466 8.42661 4.26466 7.99995C4.26466 7.57328 4.34094 7.16262 4.47172 6.77862V5.13062H2.30295C1.85612 5.99462 1.60001 6.96528 1.60001 7.99995C1.60001 9.03461 1.85612 10.0053 2.30295 10.8693L4.47172 9.22128Z"
        fill="#FBBC05"
      />
      <path
        d="M8.13888 4.13331C9.10339 4.13331 9.96436 4.45864 10.6455 5.09331L12.5091 3.26931C11.3811 2.23464 9.90442 1.59998 8.13888 1.59998C5.58322 1.59998 3.3763 3.03998 2.30281 5.13064L4.47159 6.77864C4.98926 5.25864 6.43329 4.13331 8.13888 4.13331Z"
        fill="#EA4335"
      />
    </svg>
  );
}
